// Tiempo de inactividad en milisegundos (5 minutos)
const INACTIVITY_TIMEOUT = 5 * 60 * 1000;

let inactivityTimer = null;

// Función para guardar la sesión (usa sessionStorage en lugar de localStorage)
export const guardarSesion = (usuario) => {
  sessionStorage.setItem('usuario', JSON.stringify(usuario));
  resetearTemporizador();
};

// Función para obtener la sesión
export const obtenerSesion = () => {
  const usuarioGuardado = sessionStorage.getItem('usuario');
  if (usuarioGuardado) {
    resetearTemporizador();
    return JSON.parse(usuarioGuardado);
  }
  return null;
};

// Función para cerrar sesión
export const cerrarSesion = () => {
  sessionStorage.removeItem('usuario');
  if (inactivityTimer) {
    clearTimeout(inactivityTimer);
    inactivityTimer = null;
  }
  // Redirigir al login
  window.location.href = '/login';
};

// Función para resetear el temporizador de inactividad
const resetearTemporizador = () => {
  // Limpiar el temporizador anterior si existe
  if (inactivityTimer) {
    clearTimeout(inactivityTimer);
  }

  // Crear un nuevo temporizador
  inactivityTimer = setTimeout(() => {
    cerrarSesion();
  }, INACTIVITY_TIMEOUT);
};

// Función para inicializar el monitoreo de actividad
export const inicializarMonitoreoActividad = () => {
  // Eventos que indican actividad del usuario
  const eventos = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];

  // Agregar listeners para todos los eventos de actividad
  eventos.forEach((evento) => {
    document.addEventListener(evento, resetearTemporizador, true);
  });

  // Iniciar el temporizador por primera vez
  resetearTemporizador();
};

// Función para limpiar los listeners (útil al desmontar)
export const limpiarMonitoreoActividad = () => {
  const eventos = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];
  
  eventos.forEach((evento) => {
    document.removeEventListener(evento, resetearTemporizador, true);
  });

  if (inactivityTimer) {
    clearTimeout(inactivityTimer);
    inactivityTimer = null;
  }
};
